import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/Footer';
import './ICAIMPage.css';

const stats = [
  { value: '80+', label: 'Research Papers', detail: 'High-quality papers on interdisciplinary subjects', icon: 'document' },
  { value: '4+', label: 'Competitions', detail: 'Codathon, Digital Collage, Digital Story & Treasure Hunt', icon: 'award' },
  { value: '3+', label: 'Global Partners', detail: 'AMC, MACCIA, and NCSH', icon: 'globe' },
  { value: 'Virtual', label: 'Conference Mode', detail: 'Fully online interdisciplinary conference', icon: 'screen' },
  { value: 'COVID-19 Crisis', label: 'Vision Focus', detail: 'Sustainability in agriculture & medicine', icon: 'eye' },
];

const heroHighlights = ['COVID-19 Crisis', 'Virtual Clinic', 'Sustainable Agriculture', 'Telemedicine', 'IoT & Data Science'];

const themes = [
  {
    title: 'Agriculture',
    description: 'Tackling challenges faced by farmers during COVID-19, IT for Agri-Marketing, AI, and precision agriculture.',
    tone: 'green',
  },
  {
    title: 'Healthcare (Medicine)',
    description: 'Virtual Clinics, telemedicine, confronting the pandemic with IT, and adapting medical practice in COVID times.',
    tone: 'blue',
  },
  {
    title: 'Information Technology',
    description: 'IoT sensor connectivity, Data Science with R Programming, AI solutions, and digital innovation for sustainability.',
    tone: 'violet',
  },
];

const preConferenceSchedule = [
  { date: '15-02-2021', time: 'Session', topic: 'IT in Healthcare – COVID-19 Crisis', speaker: 'Mr. Balasubramanian Sundararaman, CEO - Natural Minds' },
  { date: '16-02-2021', time: 'Session', topic: 'Marketing in Agriculture – Using IT', speaker: 'Mr. Mithil Gandhi, Co-founder - Ujjay' },
  { date: '17-02-2021', time: 'Session', topic: 'AI in Agriculture', speaker: 'Mr. Jishnu Radhakrishnan, Project Engineer, Pantech Solutions' },
  { date: '18-02-2021', time: 'Session', topic: 'Use of IT for confronting the COVID-19 crisis - Sweden', speaker: 'Mr. Daniel Eriksson, Founder NCSH' },
  { date: '18-02-2021', time: 'Session', topic: 'Precision agriculture for sustainability', speaker: 'Bo Stenberg, Dept. of Soil and Environment, SLU, Sweden' },
  { date: '16 & 18 Feb 2021', time: 'Workshop', topic: 'IoT Workshop (Sensors with Arduino)', speaker: 'TIMSCDR IoT Team' },
  { date: '17 & 18 Feb 2021', time: 'Workshop', topic: 'Data Science with R Programming', speaker: 'TIMSCDR Faculty' }
];

const sessionChairs = [
  'Sudhir Dhage, Professor, Sardar Patel Institute of Technology',
  'Bharati Veerendra Wukkadada, Assistant Professor, IT Dept, K. J. Somaiya',
  'Manish Deshmukh, Assistant Professor & HOD, Sonopant Dandekar Arts',
  'Aparna Deshmukh, Head, Biotechnology, Thakur College of Science & Commerce',
  'Dr. Kriti Waghmare, Assistant Professor, Navinchandra Mehta Institute'
];

const paperAwards = [
  { category: '1st Prize', title: 'Identifying Mental Health using Image and Color Psychology', authors: 'Ms. Nikhita Lomate and Mr. Kaushik Gawad' },
  { category: '2nd Prize', title: 'The Social Distancing- ID card', authors: 'Mr. Anurag Singh and Mr. Mahesh Shinde' }
];

const partners = ['AMC', 'MACCIA', 'NCSH'];

// ---> UPDATED GALLERY IMAGES
const galleryCards = [
  { title: 'Virtual Inauguration', src: '/ICAIM/ICAIM2021/imgi_3_01-santosh-mandlecha2.png' },
  { title: 'Keynote Speakers', src: '/ICAIM/ICAIM2021/imgi_8_06-Akshay-shah.png' },
  { title: 'Panel Discussion', src: '/ICAIM/ICAIM2021/imgi_15_13-open-forum.png' },
  { title: 'Virtual Clinic Workshop', src: '/ICAIM/ICAIM2021/imgi_16_14-Doctor-workshop.png' },
  { title: 'Student Competitions', src: '/ICAIM/ICAIM2021/imgi_12_10-Nishant-Dubey.png' }
];

// ---> UPDATED CAROUSEL IMAGES
const carouselImages = [
  '/ICAIM/ICAIM2021/imgi_6_04-Dr-vinita-Gaikwad.png',
  '/ICAIM/ICAIM2021/imgi_15_13-open-forum.png',
  '/ICAIM/ICAIM2021/imgi_9_07-Stuti-verma.png'
];

const icon = (kind) => {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: '1.9', strokeLinecap: 'round', strokeLinejoin: 'round' };
  if (kind === 'calendar') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" {...common} /><path d="M8 3v4M16 3v4M3 10h18" {...common} /></svg>;
  if (kind === 'location') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.4 6-11a6 6 0 1 0-12 0c0 5.6 6 11 6 11Z" {...common} /><circle cx="12" cy="10" r="2.5" {...common} /></svg>;
  if (kind === 'screen') return <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="12" rx="2" {...common} /><path d="M8 21h8M12 17v4" {...common} /></svg>;
  if (kind === 'document') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3h7l4 4v14H7V3Z" {...common} /><path d="M14 3v5h5M10 13h6M10 17h6M10 9h2" {...common} /></svg>;
  if (kind === 'user') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" {...common} /><path d="M5 21c1.2-4 4-6 7-6s5.8 2 7 6" {...common} /></svg>;
  if (kind === 'globe') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" {...common} /><path d="M3 12h18M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3c-2.2 2.4-3.3 5.4-3.3 9S9.8 18.6 12 21" {...common} /></svg>;
  if (kind === 'group') return <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="9" r="3.2" {...common} /><circle cx="17" cy="10" r="2.6" {...common} /><path d="M3.5 21c.9-3.9 3-6 5.5-6s4.6 2.1 5.5 6M14.5 16c2.4.2 4.2 1.9 5 5" {...common} /></svg>;
  if (kind === 'eye') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.6-6 9.5-6 9.5 6 9.5 6-3.6 6-9.5 6-9.5-6-9.5-6Z" {...common} /><circle cx="12" cy="12" r="3" {...common} /></svg>;
  if (kind === 'arrow') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" {...common} /></svg>;
  if (kind === 'leaf') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14c0-5.5 4.5-10 10-10h4v4c0 5.5-4.5 10-10 10H5v-4Z" {...common} /><path d="M8 16c3-5 6-7 11-10" {...common} /></svg>;
  if (kind === 'medical') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2" {...common} /><path d="M12 8v8M8 12h8" {...common} /></svg>;
  if (kind === 'chip') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2" {...common} /><path d="M9 1v4M15 1v4M9 19v4M15 19v4M1 9h4M1 15h4M19 9h4M19 15h4" {...common} /></svg>;
  if (kind === 'download') return <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" {...common} /></svg>;
  if (kind === 'award') return <svg width="36" height="36" stroke="#ffffff" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="5" {...common} /><path d="M8.5 13.5 7 21l5-3 5 3-1.5-7.5" {...common} /></svg>;
  return null;
};

const Icaim21 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const handleScrollToSection = (event, sectionId) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="icaim25Page icaim24Page">
      <Navbar />
      <main className="icaim25Main">
        <section className="icaim25Hero">
          <div className="icaim25HeroShell glass-panel-dark">
            <div className="icaim25HeroGrid" id="icaim25-content">
              <div className="icaim25HeroCopy">
                <span className="icaim25HeroKicker">ICAIM 2021</span>
                <h1 className="icaim25HeroTitle">
                  IT for Sustainability in COVID-19 Crisis
                </h1>
                <p className="icaim25HeroSubtitle">
                  Theme: "Leveraging Information Technology for Sustainability in Agriculture and Medicine – COVID 19 Crisis"
                </p>

                <div className="icaim25HeroHighlights" aria-label="Conference focus areas">
                  {heroHighlights.map((highlight) => (
                    <span key={highlight}>{highlight}</span>
                  ))}
                </div>

                <div className="icaim25HeroMetaInline">
                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('calendar')}</span>
                    <span>20 - 21 February 2021</span>
                  </div>

                  <span className="icaim25MetaSeparator">|</span>

                  <div className="icaim25MetaItemInline">
                    <span className="icaim25MetaIconInline">{icon('screen')}</span>
                    <span>TIMSCDR, Mumbai (Virtual Mode)</span>
                  </div>
                </div>

                <div className="icaim25HeroActions">
                  <a
                    href="#overview"
                    className="icaim25PrimaryButton text-center"
                    style={{ textDecoration: 'none' }}
                    onClick={(event) => handleScrollToSection(event, 'overview')}
                  >
                    <span>Explore Conference</span>
                    <span className="icaim25ButtonIcon">{icon('arrow')}</span>
                  </a>
               <a
                    href="/pdf/ICAIM/Proceeding2021.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icaim25SecondaryButton text-center"
                    style={{ textDecoration: 'none' }}
                  >
                    <span>View Publications</span>
                    <span className="icaim25ButtonIcon">{icon('document')}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25StatsSection" id="about">
          <div className="icaim25StatsGrid glass-panel-light">
            {stats.map((stat, index) => (
              <div className="icaim25StatCard" key={stat.label}>
                <div className={`icaim25StatIcon statTone${index + 1}`}>{icon(stat.icon)}</div>
                <div>
                  <div className="icaim25StatValue">{stat.value}</div>
                  <div className="icaim25StatLabel">{stat.label}</div>
                  <div className="icaim25StatDetail">{stat.detail}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25AboutSection" id="overview">
          <div className="icaim25AboutGrid">
            <div className="icaim25SectionIntro">
              <span className="icaim25SectionTag">Conference Overview</span>
              <h2>Navigating the Pandemic through Virtual Innovation.</h2>
              <p>
                Thakur Institute of Management Studies, Career Development and Research (TIMSCDR) organized <strong>ICAIM 2021</strong> on 20-21 February 2021. Due to the global pandemic, this unique interdisciplinary conference was conducted virtually, enabling discussions on how IT solutions can be leveraged in Agriculture and Healthcare during the <strong>COVID-19 Crisis</strong>.
              </p>
              <p>
                Arranged in association with AMC, MACCIA, and the Nordic Center for Sustainable Healthcare (NCSH), the event brought together eminent personalities to address futuristic avenues for IT applications in these critical domains.
              </p>
            </div>

            <div className="icaim25StageCard glass-panel-light" aria-hidden="true">
              <div className="icaim25StageHeader">ICAIM 2021</div>
              <div className="icaim25StageScreen">
                <div className="icaim25CarouselTrack">
                  {carouselImages.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Conference slide ${index + 1}`}
                      className={`icaim25CarouselImg ${index === currentSlide ? 'active' : ''}`}
                    />
                  ))}
                  <div className="icaim25CarouselOverlay"></div>
                </div>
                <div className="icaim25StageAudience" />
              </div>
            </div>
          </div>
        </section>

        <section className="icaim25ThemeSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Theme Focus</span>
          </div>
          <div className="icaim25ThemeGrid">
            {themes.map((theme, index) => (
              <article className={`icaim25ThemeCard tone-${theme.tone}`} key={theme.title}>
                <div className="icaim25ThemeCardIcon">
                  {icon(index === 0 ? 'leaf' : index === 1 ? 'medical' : 'chip')}
                </div>
                <h3>{theme.title}</h3>
                <p>{theme.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="icaim25NarrativeSection" id="events">
          <div className="icaim25CenteredHeading" style={{ marginTop: '50px' }}>
            <span className="icaim25SectionTag">Event Highlights</span>
          </div>
          <div className="icaim25NarrativeGrid">
            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 1 - 20 February 2021</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Virtual Inauguration & Agriculture Focus</h3>
              </div>
              <p>
                Virtually inaugurated by Chief Guest <strong>Mr. Santosh Mandlecha</strong> (President, MACCIA) alongside Mr. Milind Prabhu, Dr. Suresh Shan, Mr. Akshay Shah, and Dr. Vinita Gaikwad. The Conference Proceedings featuring 70 initial research papers were unveiled.
              </p>
              <p>
                Eminent sessions included <strong>Mrs. S. Bhadsawale</strong> (SagunaBaug) and <strong>Mr. Rajendra Bhat</strong> on farming challenges during COVID-19, <strong>Ms. Stuti Verma</strong> (Digital Green) on IT in agriculture, and discussions by founders of Frutunes and Crophunt on Agri-Marketing.
              </p>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-accent)' }}>Day 2 - 21 February 2021</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Healthcare & The Virtual Clinic</h3>
              </div>
              <p>
                The healthcare domain was inaugurated by Chief Guest <strong>Dr. Deepak Baid</strong> (President, AMC), marked by the unveiling of the workshop book <em>"Virtual Clinic – COVID-19 Scenario"</em> in the presence of esteemed doctors and IT professionals.
              </p>
              <p>
                Erudite sessions explored IT in Healthcare during COVID-19 by <strong>Mr. Balasubramanian Sundararaman</strong> and insights from Sweden by <strong>Mr. Daniel Eriksson</strong>. A compelling panel discussion on <em>"How Information Technology is Changing My Practice in COVID Times and Beyond"</em> was moderated by Dr. Mukesh Gupta and Dr. Vikrant Desai, featuring leading medical experts.
              </p>
            </article>
          </div>
        </section>

        <section className="icaim25FeatureSection" id="speakers">
          <div className="icaim25FeatureGrid">
            <article className="icaim25DarkPanel glass-panel-dark">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag">Workshops &amp; Special Events</span>
                <h2>Applied learning and skill development.</h2>
              </div>
              <div className="icaim25WorkshopGrid">
                <div className="icaim25WorkshopCard highlight-green">
                  <h3>Doctor&apos;s Workshop</h3>
                  <p>Virtual Clinic – COVID-19 Scenario. A specialized session addressing remote healthcare delivery.</p>
                  <ul>
                    <li>What is telemedicine in healthcare?</li>
                    <li>How website will help to set up virtual clinic?</li>
                    <li>How to promote virtual clinic?</li>
                  </ul>
                </div>
                <div className="icaim25WorkshopCard highlight-orange">
                  <h3>Technical Student Workshops & Competitions</h3>
                  <p>Engaging students through pre-conference hands-on tech events and digital competitions.</p>
                  <div className="icaim25JudgesBlock">
                    <strong>Highlights</strong>
                    <span>IoT Workshop (Sensors with Arduino)</span>
                    <span>Data Science Workshop (R Programming)</span>
                    <span>Competitions: Codathon, Digital Collage, Digital Story – COVID-19, Treasure Hunt</span>
                  </div>
                </div>
              </div>
            </article>

            <article className="icaim25NarrativeCard glass-panel-light" id="pre-conference">
              <div className="icaim25PanelHeader">
                <span className="icaim25PanelTag" style={{ color: 'var(--icaim-primary)' }}>Pre-Conference</span>
                <h3 style={{ marginTop: '8px', fontSize: '1.6rem', color: 'var(--icaim-text)' }}>Expert Sessions</h3>
              </div>
              <p style={{ marginBottom: '16px' }}>
                Conducted for students from 15-18 February 2021, exploring AI, Data Analytics, and global tech responses to the pandemic.
              </p>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Topics</th>
                      <th>Speaker Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConferenceSchedule.map((session, i) => (
                      <tr key={i}>
                        <td><strong>{session.date}</strong><br /><span style={{ fontSize: '0.85em', color: 'var(--icaim-text-muted)' }}>{session.time}</span></td>
                        <td>{session.topic}</td>
                        <td>{session.speaker}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        <section className="icaim25ResearchSection" id="awards">
          <div className="icaim25CenteredHeading" style={{ marginTop: '80px' }}>
            <span className="icaim25SectionTag">Proceedings & Recognitions</span>
            <h2 style={{ fontSize: '2.2rem', marginTop: '10px' }}>80 Research Papers</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '700px', margin: '10px auto' }}>
              Selected after a rigorous review process and presented virtually before distinguished professionals from Agriculture, Healthcare, and IT sectors.
            </p>
          </div>

          <div className="icaim25SessionChairs" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '40px' }}>
            {sessionChairs.map((chair, i) => (
              <span key={i} className="icaim25Badge">{chair}</span>
            ))}
          </div>

          <div className="icaim25AwardsStack">
            <article className="icaim25NarrativeCard glass-panel-light">
              <h3 style={{ color: 'var(--icaim-primary)', marginBottom: '16px' }}>Research Paper Awards</h3>
              <div className="icaim25TableWrap glass-table">
                <table className="icaim25Table">
                  <thead>
                    <tr>
                      <th>Award Category</th>
                      <th>Research Paper Title</th>
                      <th>Authors</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paperAwards.map((award, i) => (
                      <tr key={i}>
                        <td><strong style={{ color: award.category.includes('1st Prize') ? 'var(--icaim-accent)' : 'inherit' }}>{award.category}</strong></td>
                        <td>{award.title}</td>
                        <td>{award.authors}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </section>

        {/* <section className="icaim25PublicationsSection" id="publications" style={{ padding: '60px 20px', background: 'var(--icaim-bg-alt)' }}>
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Publications</span>
            <h2 style={{ fontSize: '2rem', marginTop: '10px' }}>Virtual Clinic & ICAIM 2021 Journal</h2>
            <p style={{ color: 'var(--icaim-text-muted)', maxWidth: '600px', margin: '15px auto 30px' }}>
              Access the "Virtual Clinic – COVID-19 Scenario" workshop book and the official published journal featuring interdisciplinary research papers.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a 
                href="/path/to/Virtual-Clinic-Book.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25PrimaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('download')}</span>
                <span>Download "Virtual Clinic" Book</span>
              </a>
              <a 
                href="/path/to/ICAIM-2021-Journal-Publication.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="icaim25SecondaryButton" 
                style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}
              >
                <span className="icaim25ButtonIcon" style={{ margin: 0 }}>{icon('document')}</span>
                <span>Download ICAIM 2021 Journal</span>
              </a>
            </div>
          </div>
        </section> */}

        <section className="icaim25PartnersSection">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Our Partners &amp; Associations</span>
          </div>
          <div className="icaim25PartnersGrid">
            {partners.map((partner) => (
              <div className="icaim25PartnerCard glass-panel-light" key={partner}>
                <div className="icaim25PartnerMark">{partner.charAt(0)}</div>
                <div className="icaim25PartnerName">{partner}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="icaim25GallerySection" id="gallery">
          <div className="icaim25CenteredHeading">
            <span className="icaim25SectionTag">Glimpses From ICAIM 2021</span>
          </div>
          <div className="icaim25GalleryGrid">
            {galleryCards.map((card, index) => (
              <div className={`icaim25GalleryCard gallery-${index + 1}`} key={card.title}>
                <img
                  src={card.src}
                  alt={card.title}
                />
                <span>{card.title}</span>
              </div>
            ))}
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Icaim21;